import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseResponse, BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { NotificationEndpoint } from '@m4u-angular/core/endpoints/notification.endpoint';
import { PushMessageEndpoint } from '@m4u-angular/core/endpoints/push-message.endpoint';
import { NotificationConfigurationBaseService } from '@m4u-angular/core/framework/notification-configuration-base.service';
import { DateHelpers } from '@m4u-angular/core/helpers/DateHelpers';
import { AppInjector } from '@m4u-angular/core/injector/injector.module';
import { BottomSheetContext } from 'swipe-bottom-sheet/angular';
import { Notification } from '../../../base/entities/BaseEntities';

@Component({
    providers: ServiceBagServices,
    selector: 'app-push-message',
    templateUrl: './push-message.component.html',
    styleUrls: ['./push-message.component.scss']
})
export class PushMessageComponent extends BaseComponent<BaseState> {

    private _notification: Notification;
    @Input() set Notification(value: Notification) {
        if (!value) return;
        this._notification = value;
        this.NotificationButtons = this.notificationConfigurationService.GetButtons(value);
    }
    get Notification() { return this._notification; }

    @Input() BottomSheetContext: BottomSheetContext<any>;
    @Output() OnNotificationRead = new EventEmitter();

    NotificationButtons: any[];

    constructor(A: ServiceBagService,
        private pushMessageEndpoint: PushMessageEndpoint,
        private notificationConfigurationService: NotificationConfigurationBaseService) {
        super(A, 'PushMessageComponent', BaseState);
    }

    OnItemClick() {
        if (!this.Notification || this.Notification.IsRead) return;

        this.Notification.IsRead = true;
        setTimeout(() => this.Do(this.pushMessageEndpoint.ReadPushNotification(this.Notification.EntryID), false,
            (response: BaseResponse) => response.IsSuccess && this.OnNotificationRead.emit()), 500);
    }

    IsNotificationButtonsExists() {
        return this.NotificationButtons && this.NotificationButtons.length && this.NotificationButtons.some(x => x.Visible);
    }
}
